import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AddIcon from '@mui/icons-material/Add';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import GavelIcon from '@mui/icons-material/Gavel';
import HelpIcon from '@mui/icons-material/Help';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InfoIcon from '@mui/icons-material/Info';
import InsightsIcon from '@mui/icons-material/Insights';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import LaunchIcon from '@mui/icons-material/Launch';
import LockIcon from '@mui/icons-material/Lock';
import MenuIcon from '@mui/icons-material/Menu';
import PanToolIcon from '@mui/icons-material/PanTool';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import StarIcon from '@mui/icons-material/Star';
import StarOutlinedIcon from '@mui/icons-material/StarOutline';
import StoreIcon from '@mui/icons-material/Store';

export const iconMap: Record<string, React.ComponentType<any>> = {
  add: AddIcon,
  arrow_forward_ios: ArrowForwardIosIcon,
  attach_money: AttachMoneyIcon,
  check_circle: CheckCircleIcon,
  compare_arrows: CompareArrowsIcon,
  dashboard: DashboardIcon,
  delete: DeleteIcon,
  edit: EditIcon,
  expand_less: ExpandLessIcon,
  expand_more: ExpandMoreIcon,
  file_download: FileDownloadIcon,
  gavel: GavelIcon,
  help: HelpIcon,
  help_outline: HelpOutlineIcon,
  info: InfoIcon,
  insights: InsightsIcon,
  keyboard_arrow_right_rounded: KeyboardArrowRightRoundedIcon,
  keyboard_arrow_left_rounded: KeyboardArrowLeftRoundedIcon,
  keyboard_arrow_down_rounded: KeyboardArrowDownRoundedIcon,
  keyboard_arrow_up_rounded: KeyboardArrowUpRoundedIcon,
  launch: LaunchIcon,
  'lock-icon': LockIcon,
  menu: MenuIcon,
  pan_tool: PanToolIcon,
  people: PeopleIcon,
  settings: SettingsIcon,
  star: StarIcon,
  star_outlined: StarOutlinedIcon,
  store: StoreIcon,
  account_balance: AccountBalanceIcon
};
